import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, isTTC } from '../hooks/useAuth';
import { StatusBadge } from '../components/StatusBadge';
import api from '../utils/api';
import { formatDistanceToNow } from 'date-fns';

const STATUSES = ['submitted','approved','in_production','shipped','delivered'];

export default function DashboardPage() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/orders?limit=5').then(r => {
      setData(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const counts = {};
  if (data?.orders) {
    for (const s of STATUSES) counts[s] = 0;
    for (const o of data.orders) {
      if (counts[o.status] !== undefined) counts[o.status]++;
    }
  }

  return (
    <>
      <div className="topbar">
        <h2>Dashboard</h2>
        <Link to="/catalog" className="btn btn-gold btn-sm">+ New Order</Link>
      </div>
      <div className="page">
        <div className="stats-grid">
          {STATUSES.map(s => (
            <div className="stat-card" key={s}>
              <div className="stat-label">{s.replace(/_/g,' ')}</div>
              <div className="stat-value">{data ? (counts[s] ?? '—') : '—'}</div>
            </div>
          ))}
          {data && (
            <div className="stat-card">
              <div className="stat-label">Total Orders</div>
              <div className="stat-value">{data.total}</div>
            </div>
          )}
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Recent Orders</h3>
            <Link to="/orders" className="btn btn-secondary btn-sm">View All</Link>
          </div>
          {loading ? (
            <div className="loading">Loading…</div>
          ) : !data?.orders?.length ? (
            <div className="empty-state">No orders yet.</div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Order #</th>
                    {isTTC(user) && <th>Customer</th>}
                    <th>Status</th>
                    <th>Total</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {data.orders.map(o => (
                    <tr key={o.id}>
                      <td><strong>{o.order_number}</strong></td>
                      {isTTC(user) && <td>{o.customer_name}</td>}
                      <td><StatusBadge status={o.status} /></td>
                      <td>{o.total_amount ? `$${Number(o.total_amount).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}` : '—'}</td>
                      <td className="text-muted text-sm">{formatDistanceToNow(new Date(o.created_at), {addSuffix:true})}</td>
                      <td><Link to={`/orders/${o.id}`} className="btn btn-ghost btn-sm">View</Link></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
